import { useContext } from 'react';

import { TimeseriesInfiniteZoomContext } from '../context/TimeseriesInfiniteZoom.context.js';

export const useInfiniteZoomConfig = () =>
  useContext(TimeseriesInfiniteZoomContext);
